import api from '@/api'
import * as types from './mutations-types'
import { get_tUser } from '@/assets/js/util';
import { getSignature, dealSignatrue } from '~/assets/js/util'
// import router from '@/router'

// export const getAccountUsersMobileAccountIndex = async function ({ commit }) {
//   let params = await dealSignatrue();
//   try {
//     let json = await api.me.AccountUsersMobileAccountIndex(this.$axios, params)
//     commit(types.GET_INFO, json.data)
//     commit(types.IS_MEMBERSHIP, json.data && json.data.is_membership || '')
//   } catch (error) {
//     // commit('IS_USER', true)
//     console.log(error)
//   }
//   commit('IS_USER', true)
// }

// export const personMenu = async function ({ commit }) {
//   let params = await dealSignatrue()
//   let data = await api.me.personMenu(params)
//   commit('SET_PERSON_MENU', data)
// }

// export const getMobileAccountUsersBuyMember = async function ({ commit }, params) {
//   try {
//     let buyMember = await api.me.MobileAccountUsersBuyMember(params)
//     commit(types.GET_BUY_MEMBER_DATA, buyMember.data)
//   } catch (error) {
//     console.log(error)
//   }
// }

// export const getUdeskOnlineUrl = async function ({ commit }, params) {
//   try {
//     let res = await api.me.getUdeskOnlineUrl(params)
//     commit(types.GET_UDESK_ONLINE_URL, res.data.udesk_online_url)
//   } catch (error) {
//     console.log(error)
//   }
// }
export const setPublicKey = function ({ commit }, params) {
  commit(types.PUBLIC_KEY, params)
}
export const setprivateKey = function ({ commit }, params) {
  commit(types.PRIVATE_KEY, params)
}
export const setIsLogin = function ({ commit }, params) {
  commit(types.IS_LOGIN, params)
}
export const getUserInfo = async ({ state, commit }, cv_account_token) => {
  cv_account_token = cv_account_token || await get_tUser().c_t;
  let res = {};
  if(cv_account_token){
    res = await api.me.getUserInfo(cv_account_token);
  }
  if (res.code !== 1000) return res;
  commit('GET_INFO', res.data || {});
  commit('IS_MEMBERSHIP', res.data.is_membership);
  return res;
}
// 修改用户个人信息
export const setUserPersonInfo = ({ commit }, personInfo) => {
  commit('GET_INFO', personInfo)
}
// 获取用户求职身份
export const getUserIdentify = async ({ commit }, cv_account_token) => {
  try {
    let res = await api.cvsV2.getIdentifyInfo(cv_account_token)
    if (res.code === 1000) {
      commit(types.GET_USER_IDENTIFY, res.data.status)
    }
  } catch (error) {
  }
}

export const getPurchaseRecordData = async ({ commit }, data) => {
  try {
    let res = await api.account.isHalfYearMember();
    if (res.code === 1000) {
      commit(types.SET_PURCHASE_RECORD_DATA, res.data);
    }
  } catch (error) {
    console.log(`fetch purchase record data error: ${error}`)
  }
}
